import React from 'react';
import FeedContainerSimple from './FeedContainerSimple.jsx';
import _ from 'lodash';
import { connect } from 'react-redux';
import { appContext } from '../../util/decorators';
import { loadAction } from '../../util/decorators';
import FeedContainerBox from 'component/NewsFeed/FeedContainerBox.jsx';
import RowWithThreeBox from './RowWithThreeBox.jsx';


const mapStateToProps = state => ({
  popularVideos: state.dataSources.popularVideos,
  boxArticles:   state.dataSources.boxArticles,
  routeParams: state.routeParams,
  country: state.country,
});

const $loadBoxArticlesDataSources = args => {
  return loadDataSources({
    ...args,
    dataSourceConfigs: {
      boxArticles: 'boxArticles'
    },
    limit: {
      boxArticles: 3
    },
  });
};

@loadAction($loadBoxArticlesDataSources)
@connect(mapStateToProps)
@appContext
export default class PopularVideosBox extends React.PureComponent {
  render() {
    const { popularVideos, routeParams, country, boxArticles } = this.props;

    if (_.isEmpty(_.head(popularVideos))) return null;

    let useVideoTypeTags = false;
    let subHeading = routeParams.sports;
    if (routeParams.teams) {
      const teamTags = _.get(popularVideos, 'tags.teams');
      const teamTag = _.find(teamTags, tag => (tag[country] || tag.en).slug === routeParams.teams);
      subHeading = _.get(teamTag, `${country}.name`) || _.get(teamTag, 'en.name');
      useVideoTypeTags = true;
    } else if (routeParams.competitions) {
      subHeading = _.get(popularVideos, `[0].tags.competitions[0].${country}.name`);
      useVideoTypeTags = true;
    }

    const rows = _.chunk(popularVideos, 2);

    return (
      <div className="row">

        <div className="template-item col-md-12">
          <div className="popular-videos">
          	<h3 className="box-title">Retro – Gyldne klip fra arkivet</h3>
             <div className="index-box">
				<RowWithThreeBox articles={boxArticles} className="featured-news"/>
             </div>
         </div>
       </div>
        
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/NewsFeed/PopularVideosBox.jsx